package com.sweetlime.bingeamigo.error

class TmdbRateLimitException(
    message: String = "TMDb rate limit exceeded. Please wait a moment and try again."
) : Exception(message)